<template>
  <v-container>
    <ValidationObserver ref="form">
      <FormToolbar
        :title="edit ? 'Edit Vessel' : 'New Vessel'"
        :onSubmitClick="submitForm"
        :onCloseClick="onCloseClick"
      />
      <v-form class="mt-1" @keyup.enter.native="submitForm">
        <v-container>
          <v-row>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Name"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  ref="firstInput"
                  v-model="entity.name"
                  :error-messages="errors"
                  label="Name"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                disabled
                v-if="edit"
                v-model="entity.isActive"
                label="Active"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-text-field class="hidden" />
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';

export default {
  props: {
    edit: Boolean,
    entity: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    bus: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  mounted() {
    this.bus.$on('resetForm', this.resetForm);
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) this.onSubmitClick();
        });
    },
    resetForm() {
      this.$nextTick(() => this.$refs.firstInput.focus());
      this.$refs.form.reset();
    },
  },
};
</script>
